import { CustomCheckbox } from '../../components/UI/CustomCheckbox/CustomCheckbox';
import FormElement from '../FormElement';
import ICommonFormProps from '../interfaces/ICommonFormProps';

export function FormCustomCheckbox(props: ICommonFormProps) {
    function onChange(selected: boolean) {
        if (props.setValue) {
            props.setValue(props.keyName, selected);
        }
    }

    return (
        <FormElement {...props}>
            <CustomCheckbox
                onChange={onChange}
                title={props.label}
                checked={props.value}
                dataComponentName={props.keyName}
                disabled={props.disabled}
            />
        </FormElement>
    );
}
